const fontSizes = {
  caption: '12px',
  body: '14px',
  bodyLarge: '18px',
  headingSmall: '24px',
  heading: '30px',
};

export default fontSizes;
